import React from 'react';

import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import './Terms.css';

const styles = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.75)'
  },
  actions: {
    padding: '0 24px 24px'
  }
};

const Terms = props => {
  const actions = [
    <RaisedButton label="Accept" primary={true} onClick={props.handleAccept} />
  ];

  return (
    <Dialog
      className="terms-dialog"
      overlayStyle={styles.overlay}
      actionsContainerStyle={styles.actions}
      title="WARNING TO USERS OF THIS SYSTEM"
      actions={actions}
      modal={true}
      open={true}
    >
      <h5>
        THIS IS A NOTICE OF MONITORING OF THE DEPARTMENT OF INTERIOR (DOI)
        INFORMATION SYSTEMS.
      </h5>

      <p>
        This computer system, including all related equipment, networks, and
        network devices (Including Internet access), is provided by the
        Department of Interior (DOI) in accordance with the agency policy for
        official use and limited personal use.
      </p>

      <p>
        All agency computer systems may be monitored for all lawful purposes,
        including but not limited to, ensuring the use is authorized, for
        management of the system, to facilitate protection against unauthorized
        access, and to verify security procedures, survivability and operational
        security.  Any information on this computer system may be examined,
        recorded, copied and used for authorized purposes at any time.
      </p>

      <p>
        All information, including personal information, placed or sent over
        this system may be monitored, and users of this system are reminded that
        such monitoring does occur.  Therefore, there should be no expectation
        of privacy with respect to use of this system.
      </p>

      <p>
        By logging into this agency computer system, you acknowledge and consent
        to the monitoring of this systems.  Evidence of your use, authorized or
        unauthorized, collected during monitoring may be used in civil,
        criminal, administrative, or other adverse action.  Unauthorized or
        illegal use may subject you to prosecution.
      </p>
    </Dialog>
  );
};

export default Terms;



// WEBPACK FOOTER //
// ./src/components/Terms.js